import React, { useEffect, useState } from 'react';
import {
  ColumnGap,
  FlexDirectionWrapper,
  MainContent,
  SubTitle,
  Text,
} from '../../../../../components/StyledComponents';
import { SearchInputAdmin } from '../../../../../components/SearchInputAdmin';
import { formatDateToBR } from '../../../../../utils/time';
import FiltersModel from '../../../filters.model';
import { removeEmpty } from '../../../../../utils/utils';
import { TableAdmin } from '../../../../../components/TableAdmin';
import { handleModalAdmin } from '../../../../../utils/handleModalAdmin';
import { AtendimentoRecusadoService } from '../../../services/atendimentoRecusadoService';

import { cnpjMask, numberLocale, } from '../../../../../utils/mask';

const tableColumns = [
  {
    field: 'dataCriacao',
    id: 'dataCriacao',
    label: 'Data',
    minWidth: 10,
    handleField: formatDateToBR,
  },
  {
    field: 'atendente',
    id: 'atendente',
    handleField: (atendente) => <p>{atendente?.uf?.sigla}</p>,
    label: 'UF',
    align: 'left',
    minWidth: 10,
  },
  {
    field: 'atendente',
    id: 'atendente',
    handleField: (atendente) => <p>{atendente?.nome}</p>,
    label: 'Agente',
    align: 'left',
    minWidth: 10,
  },
  {
    field: 'cnpj',
    id: 'cnpj',
    label: 'CNPJ',
    align: 'left',
    minWidth: 135,
    handleField: cnpjMask,
  },
  {
    field: 'actions',
    id: 'actions',
    label: '',
    minWidth: 10,
    align: 'left',
  },
];

export const Gerenciar = () => {
  const {
    inputSearchValue,
    setInputSearchValue,
    filters,
    paginationFilters,
    handleOrderClick,
    onLinesPerPageChange,
    handlePageChange,
    handleInputPageChange,
    isLoading,
    setIsLoading,
    showModal,
  } = FiltersModel({
    orderBy: 'dataCriacao',
  });
  
  const [data, setData] = useState([]);
  
  const getBodyParams = () => {
    return removeEmpty({...filters, oqueVoceProcura: inputSearchValue});
  };
  
  const getData = async () => {
    try {
      const bodyParams = getBodyParams();
      console.log('booody', bodyParams);
      const response = await AtendimentoRecusadoService.findAll(
          paginationFilters,
          bodyParams
      );
      setData(response);
    } catch (e) {
      console.log('erro =>>', e);
    } finally {
      setIsLoading(false);
    }
  };
  
  useEffect(() => {
    getData();
    // https://github.com/facebook/create-react-app/issues/6880
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginationFilters, filters, inputSearchValue]);
  

  
  const handleDeleteClick = (id) => {
    handleModalAdmin({
      title: `Excluir`,
      content: `Você tem certeza que deseja excluir esse registro?`,
      msgOnSuccess: `Registro excluído com sucesso`,
      showAPIErrorIfAvailable: true,
      onFinish: () => {
        setIsLoading(true);
        setData([]);
        getData();
      },
      onConfirmClick: async () => await AtendimentoRecusadoService.deleteById(id),
      showModal: showModal,
    });
  };
  
  return (
      <MainContent>
        <SubTitle>
          <>
            <h3>Gerenciar</h3>
            <SearchInputAdmin
                value={inputSearchValue}
                onChange={setInputSearchValue}
            />
          </>
        </SubTitle>
        
        
        <FlexDirectionWrapper
            style={{justifyContent: 'space-between', marginTop: '12px'}}
        >
          <ColumnGap gap="4px">
            <Text color="#0061C6" weight="bold">
              {numberLocale(data?.totalElements) ?? 0}
            </Text>
            <Text color="#B3B3B3">
              {data?.totalElements === 1 ? 'resultado' : 'resultados'} encontrados
            </Text>
          </ColumnGap>
        
        </FlexDirectionWrapper>
        
        <TableAdmin
            {...{
              data,
              paginationFilters,
              isLoading,
              onLinesPerPageChange,
              handleDeleteClick,
              handleOrderClick,
            }}
            sentEntireObjectToEdit
            sentEntireObjectToCopy
            columnAction={'actions'}
            linesPerPageFilters={paginationFilters?.linesPerPage}
            pagination={true}
            totalPages={data?.totalPages}
            columns={tableColumns}
            tableColor={'#0061C6'}
            lineColor={'rgba(0, 97, 198, 0.1)'}
            onPagePreviousChange={handlePageChange}
            onPageNextChange={handlePageChange}
            onInputPageChange={handleInputPageChange}
        />
      </MainContent>
  );
};
